import { pksApiService } from '../services/pksApiService'
import { Sector } from '../entities/Sector'

class SectorCommunicator {
    fetchPage() {
        return pksApiService
            .fetchPage('/sectors')
            .then(sectorList => sectorList.map(sector => new Sector(sector)))
    }

    fetch(id) {
        return pksApiService.fetch('/sectors', id).then(sector => new Sector(sector))
    }
}

export const sectorCommunicator = new SectorCommunicator()
